import { RichText } from './post'
import { LandingPageV2, CustomComponent } from './landingPageV2'
import { BGVariants } from './heroTextSection'

export enum ModalVariants {
  Newsletter = 'Newsletter',
  ReducedPadding = 'Reduced Padding',
  ResumeUpload = 'Resume Upload',
  LanguageSwitcher = 'Language Switcher',
}

export interface ModalStep {
  name: string
  contentful_id: string
  content: RichText
  __typename: 'ContentfulModalStep'
}

export interface Modal {
  name: string
  contentful_id: string
  variant: null | ModalVariants
  steps: (ModalStep | CustomComponent)[]
  completionRedirect: null | Pick<
    LandingPageV2,
    'name' | 'slug' | '__typename' | 'contentful_id'
  >
  __typename: 'ContentfulModal'
  showCloseButton?: boolean
  color?: BGVariants | null
}
